module.exports = __webpack_public_path__ + "img/-s-icon01.50be0628.png";